<template>
    <el-dialog
            :visible.sync="visible"
            width="1000px"
            :title="title||'生成问卷'"
            @closed="dialogCloseHandler"
            custom-class="create-paper-container">

        <el-form :ref="editFormRef" :model="formData" label-width="150px" :rules="rules" @submit.native.prevent>
            <el-form-item label="问卷标题" prop="name" >
                <el-input v-model="formData.name" :disabled="readonly" placeholder="请输入问卷标题" style="width:50%"></el-input>
            </el-form-item>

            <el-form-item label="问卷主题" prop="theme" v-if="false" :rules="rules">
                <el-input type="textarea" v-model="formData.theme" :disabled="readonly" placeholder="请输入问卷主题" :rows="2"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark2" >
                <el-input  v-model="formData.remark2" :disabled="readonly" placeholder="请输入备注" style="width:50%"></el-input>
            </el-form-item>

            <!--            <el-form-item label="问卷类型" prop="type">-->
            <!--                <el-radio-group v-model="formData.type" disabled>-->
            <!--                    <el-radio label="0">普通调查问卷</el-radio>-->
            <!--                    <el-radio label="1">满意度调查问卷</el-radio>-->
            <!--                </el-radio-group>-->
            <!--            </el-form-item>-->

            <!-- <el-form-item label="人员类型" prop="audience">
                <el-radio-group v-model="formData.audience" :disabled="readonly" placeholder="请选择人员类型">
                    <el-radio label="0">业主</el-radio>
                    <el-radio label="1">全部人员</el-radio>
                </el-radio-group>
            </el-form-item> -->

            <!-- <el-form-item label="分配项目" prop="precincts" v-if="isAdmin">
                <div class="resource-bind-div" v-if="!readonly">
                    <div @click="showProject" style="cursor: pointer"> -->
                        <!--                        {{!formData.projects || formData.projects.length === 0 ? '点击选择项目' : `已选择项目[-->
                        <!--                        ${formData.projects.length} ]个`}}-->
                        <!-- {{ (formData.precincts||[]).length === 0 ? '点击选择项目' : `已选择项目[
                        ${formData.precinctNames} ]`}}
                    </div>
                </div>
                <div class="resource-bind-div" v-else>
                    <div style="cursor: pointer"> -->
                        <!--                        {{!formData.projects || formData.projects.length === 0 ? '点击选择项目' : `已选择项目[-->
                        <!--                        ${formData.projects.length} ]个`}}-->
                        <!-- {{ (formData.precincts||[]).length === 0 ? '点击选择项目' : `已选择项目[
                        ${formData.precinctNames} ]`}}
                    </div>
                </div>
                <precinct-select ref="precinctSelectRef" @submitParam="submitParam"/>
            </el-form-item> -->

            <el-form-item label="问卷开始截止时间" prop="dataRange" v-if="false">
                <el-date-picker
                        :disabled="readonly"
                        is-range
                        v-model="formData.dataRange"
                        type="daterange"
                        clearable
                        format="yy/MM/dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        placeholder="选择问卷调查时间范围"
                        end-placeholder="结束日期"
                        align="right"
                        style="width:50%">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="问卷说明" prop="remarks"  :rules="rules"> 
                <el-input type="textarea"
                          :rows="6" v-model="formData.remarks" :disabled="readonly" placeholder="请输入问卷说明"></el-input>
            </el-form-item>


            <el-form-item label="问卷题目" v-if="readonly">
                <div class="resource-bind-div" @click="showList">
                    点击查看问卷题目
                </div>
                <paper-title-option ref="paperTitleOptionRef"/>
            </el-form-item>
        </el-form>

        <span slot="footer">
            <div class="between-warp" v-if="!readonly">
                <!-- <div style="padding-top: 4px;margin-right: 50px" v-show="!formData.id">
                <span style="color: red;">
                    是否保存问卷至题库
                </span>
                <el-radio-group v-model="formData.ifSaveToBank">
                    <el-radio label="0">否</el-radio>
                    <el-radio label="1">是</el-radio>
                </el-radio-group>
                </div> -->
            <div>
                 <el-button type="success" class="button-wide" @click="submitHandler" v-if="!readonly">
                     {{formData.copyInfoId?'复制':formData.id?'保存':'生成'}}
                 </el-button>
                 <el-button type="info" class="button-wide" @click="visible = false">取消</el-button>
            </div>
            </div>
            <div v-else>
                  <el-button type="info" class="button-wide" @click="visible = false">取消</el-button>
            </div>
        </span>

    </el-dialog>
</template>

<script>

    export default JBoot({
        name: 'generate',
        componentName: 'generate',
        registryName: 'generate',
        components: {
            'precinct-select': require('./precinctSelect.vue').default,
            'paper-title-option': require('./paperTitleAndOption.vue').default,
        },

        data() {
            return {
                type: 0,
                moduleName: 'paper',
                submitMethod: 'saveAndInsertQuestionBank',
                rules: {
                    name: [{required: true, message: '请输入问卷标题'}, {min: 1, max: 225, message: '名称为1~200个字符'}],
                    //  theme: [{required: true, message: '请输入问卷主题'}, {min: 1, max: 225, message: '字典名称为1~200个字符'}],
                    remarks: [{required: true, message: '请输入问卷说明'}, {min: 1, max: 225, message: '名称为1~200个字符'}],
                    // dataRange: [{required: true, message: '选择问卷调查时间范围'}],
                    // audience: [{required: true, message: '选择问卷调查人员类型'}],
                    // precincts: [{
                    //     required: true, trigger: 'blur', validator: (rule, value, callback) => {
                    //         if (!value || value.length === 0) {
                    //             callback(new Error('选择问卷调查分配项目'))
                    //         } else {
                    //             callback()
                    //         }
                    //     },
                    // }],
                    // remarks: [{min: 1, max: 225, message: '问卷内容不超过500个字符'}],
                },
            }
        },

        computed: {
            isAdmin() {
                return this.userInfo.category && this.userInfo.category == 'admin';
            },
        },


        methods: {
            submitParam(item) {
                this.$set(this, 'formData', Object.assign({}, this.formData || {}, {
                    "precincts": item.submitParams,
                    "precinctNames": item.submitParams.length > 0 ? item.submitParams.map(item => item.houseName) : [],
                    "selectionRowMap": item.selectionRowMap
                }));
            },

            showProject() {
                this.$refs['precinctSelectRef'].show(Object.assign({}, {}, {
                    selectionRowMap: this.formData.selectionRowMap || {},
                    precincts: this.formData.precincts
                }));
            },


            showList() {
                this.$refs['paperTitleOptionRef'].show(Object.assign({}, {}, {
                    infoId: this.formData.id
                }));
            },


            //是否加载表单数据
            isLoadDataInfo() {
                if (this.parentParam.id) {
                    return true;
                }
                if (!this.$route.params.routeParams) {
                    return false;
                }
                let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                return !!this.visible && routeParams.id;
            },

            //获取加载详情时的参数
            getLoadInfoParams() {
                if (this.parentParam.id) {
                    return {
                        id: this.parentParam.id
                    };
                }
                let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                return {id: routeParams.id};
            },


            initFormDataInfo(response) {
                if (response.id) {
                    if (response.precincts && response.precincts.length > 0) {
                        response.precincts = response.precincts.split(",").join(", ");
                        console.log(Array.isArray(response.precincts))
                    }
                    var arr = [];
                    arr.push(response.startTime);
                    arr.push(response.endTime);
                    this.$set(this, 'formData', Object.assign({}, response, {
                        dataRange: arr,
                        precincts: response.precincts
                    }));
                }
                this.$set(this, 'formData', Object.assign({}, this.formData || {}, {
                    "type": this.parentParam.type ? this.parentParam.type.toString() : '0',
                    "ifSaveToBank": '0'
                }));
            },

            getEditFormDataInfo() {
                let paperTypeParam ;
                if(this.$route.name == 'paperActivityInfo'||this.$route.name == 'paperActivity'){
                    paperTypeParam = 2
                }else{
                    paperTypeParam = 0
                }
                
                //如果检测到copyInfoId的话，则是问卷复制。
                return Object.assign({}, this.formData, {
                    column: this.parentParam.copyInfoId == undefined ? this.constructColumn() : null,
                    group: this.parentParam.copyInfoId == undefined ? this.constructGroup() : null,
                    // startTime: this.dateToStrings(this.formData.dataRange[0]) + " 00:00:00",
                    // endTime: this.dateToStrings(this.formData.dataRange[1]) + " 23:59:59",
                    json: this.parentParam.copyInfoId == undefined ? JSON.stringify([...this.parentParam.column, ...this.parentParam.group]) : this.parentParam.json,
                    // precincts: this.constructPrecinct('precincts'),
                    // precinctNames: this.constructPrecinct('precinctNames'),
                    copyInfoId: this.parentParam.copyInfoId == undefined ? undefined : this.parentParam.copyInfoId,
                    paperType:paperTypeParam
                });
            },

            constructPrecinct(field) {
                if (!this.formData[field]) {
                    return undefined;
                }
                if (this.isString(this.formData[field]) && field.length > 0) {
                    return this.formData[field];
                }
                if (this.formData[field].length > 0) {
                    if (this.isString(this.formData[field][0])) {
                        return (this.formData[field]).join(",");
                    } else {
                        return this.formData.precincts.map(item => item.houseID).join(",")
                    }
                }
            },

            isString(object) {
                return toString.call(object) == '[object String]';
            },

            constructColumn() {
                if (this.parentParam.column && this.parentParam.column.length > 0) {
                    this.parentParam.column.forEach(item => {
                        if (!item.dicData) {
                            item.dicData = [];
                        }
                        if (item.type == 'rate' && this.formData.type == '0' && item.texts.length > 0) {
                            item.signs = [];
                            item.texts.forEach(val => {
                                item.signs.push({
                                    label: val,
                                    value: []
                                });
                            })
                        }
                    })
                }
                return this.parentParam.column;
            },

            constructGroup() {
                console.log('this.parentParam',this.parentParam)
                if (this.parentParam.group && this.parentParam.group.length > 0) {
                    this.parentParam.group.forEach(group=>{
                        group.required = false
                        group.column.forEach(item => {
                        if (!item.dicData) {
                            item.dicData = [];
                        }
                        if (item.type == 'rate' && this.formData.type == '0' && item.texts.length > 0) {
                            item.signs = [];
                            item.texts.forEach(val => {
                                item.signs.push({
                                    label: val,
                                    value: []
                                });
                            })
                        }
                    })
                    })
                    
                }
                return this.parentParam.group;
            },

            dateToStrings(dats) {
                var date = new Date(dats);
                var year = date.getFullYear();
                var month = (date.getMonth() + 1).toString();
                var day = (date.getDate()).toString();
                if (month.length == 1) {
                    month = "0" + month;
                }
                if (day.length == 1) {
                    day = "0" + day;
                }
                var dateTime = year + "-" + month + "-" + day;
                return dateTime;
            },

            //保存题库
            saveQuestionBank(option) {
                this.$api(this.moduleName, 'saveBackTitleAndOption', option).then(response => {
                    this.submitSuccess({}, true)
                });
            },

            //提交成功之后的处理
            submitSuccess(response, flag) {
                this.$success("提交成功");
                this.dialogCloseHandler();
                this.$nextTick(function () {
                    this.$emit('submitSuccess', flag == undefined ? false : true);
                });
            },

            dialogCloseHandler() {
                if (this.visible) {
                    this.visible = false;
                } else {
                    this.$closeAllMask();
                    this.resetFormDataInfo();
                }
            },
        },

    }).store('userInfo').form().build();
</script>

<style lang="scss">
    .create-paper-container {
        & > .el-dialog__body {
            padding: 10px 15px;
        }

        .between-warp {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/generate.vue